import { Component, OnInit, Optional } from '@angular/core';
import {
  CustomerService,
  ProductService,
  AuthService,
  PriceService,
  DeliveryDateService,
  CartRow,
  GungGoogleTagManagerService
} from 'gung-standard';
import { DateUtilService } from 'gung-common';
import { JeevesDeliveryAddressesService, SummarizeOrderJeevesComponent } from 'gung-standard-jeeves';
import { environment } from './../../../../../environments/environment';
import { parse } from 'date-fns';
import { DatePipe } from '@angular/common';
import { first } from 'rxjs';
@Component({
  selector: 'helo-summarize-order-jeeves',
  templateUrl: './helo-summarize-order-jeeves.component.html',
  styleUrls: ['./helo-summarize-order-jeeves.component.css']
})
export class HeloSummarizeOrderJeevesComponent extends SummarizeOrderJeevesComponent implements OnInit {
  isUser: boolean;
  constructor(
    protected customerService: CustomerService,
    protected productService: ProductService,
    protected authService: AuthService,
    protected priceService: PriceService,
    public dateUtilService: DateUtilService,
    protected deliveryDateService: DeliveryDateService,
    protected datePipe: DatePipe,
    protected jeevesDeliveryAddressesService: JeevesDeliveryAddressesService,
    @Optional()
    protected gungGoogleTagManagerService: GungGoogleTagManagerService
  ) {
    super(
      customerService,
      productService,
      authService,
      priceService,
      dateUtilService,
      jeevesDeliveryAddressesService,
      gungGoogleTagManagerService
    );
  }

  ngOnInit() {
    super.ngOnInit();
    //https://gung-se.freshdesk.com/a/tickets/185474
    const minWorkingDaysLeadTime = 5;
    this.deliveryDateService.getDeliveryDates('').subscribe(res => {
      let workingDays = 0;
      let index = 0;
      while (workingDays < minWorkingDaysLeadTime) {
        index++;
        if (res[index].valid) {
          workingDays++;
        }
      }
      const date = res[index].date;

      const formattedDate = this.datePipe.transform(date, 'yyyy-MM-dd');
      for (const row of this.checkout.rows) {
        if (!row.extra.orp.ordberlevdat || row.extra.orp.ordberlevdat < formattedDate) {
          row.extra._log_date_change = 'Date override from ' + row.extra.orp.ordberlevdat + ' to ' + formattedDate;
          console.log('Date override from ' + row.extra.orp.ordberlevdat + ' to ' + formattedDate);
          row.extra.orp.ordberlevdat = formattedDate;
        }
      }
    });
    this.authService.getRoles().subscribe(roles => {
      this.isUser = roles.length === 1 && roles.includes('USER');
    });
  }

  protected mapProductsPrice(cartRows: CartRow[]) {
    this.priceService
      .getCartRowPricesObservable(cartRows)
      .pipe(first())
      .subscribe(priceElements => {
        this.pricesMap = {};
        priceElements.forEach(
          priceElement =>
            (this.pricesMap[
              priceElement.productId + (priceElement.productPartialId ? '_' + priceElement.productPartialId : '')
            ] = priceElement)
        );
      });
  }
}
